<template>
  <div class="content">
    <!-- <download-csv
          class   = "btn btn-primary btn-block"
          :data   = "allUsers"
          name    = "filename.csv">      
        Download Data
 
</download-csv> -->
    <br />
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>work</md-icon>
          </template>
          <template slot="content">
            <p style="font-size: 0.7rem; color: black" class="category">
              Messages
            </p>
            <h3 class="title">{{ getAllMessagedUsers }}</h3>
          </template>
        </stats-card>
      </div>
      <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="green">
          <template slot="header">
            <i class="fa fa-money"></i>
          </template>

          <template slot="content">
            <p style="font-size:0.70rem;color:black;" class="category">Meetings Created</p>
            <h3 class="title">{{active_sub_admins.length}}</h3>
          </template>
        </stats-card>
      </div> -->
      <div
        class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>supervised_user_circle</md-icon>
          </template>

          <template slot="content">
            <p style="font-size: 0.7rem; color: black" class="category">
              Providers
            </p>
            <h3 class="title">
              {{ service_providers.length }}
              <!-- <small>GB</small> -->
            </h3>
          </template>

          <!-- <template slot="footer">
            <div class="stats">
              <md-icon class="text-danger">warning</md-icon>
              <a href="#pablo">Get More Space...</a>
            </div>
          </template> -->
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-30 md-xsmall-size-100 md-size-30"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <i class="fas fa-users"></i>
          </template>

          <template slot="content">
            <p style="font-size: 0.7rem; color: black" class="category">
              Users
            </p>
            <h3 class="title">{{ clients.length }}</h3>
          </template>

          <!-- <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Just Updated
            </div>
          </template> -->
        </stats-card>
      </div>
      <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header data-background-color="orange">
            <h4 class="title">Employees Stats</h4>
            <p class="category">New employees on 15th September, 2016</p>
          </md-card-header>
          <md-card-content>
            <ordered-table table-header-color="orange"></ordered-table>
          </md-card-content>
        </md-card>
      </div> -->
      <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <nav-tabs-card>
          <template slot="content">
            <span class="md-nav-tabs-title">Tasks:</span>
            <md-tabs class="md-success" md-alignment="left">
              <md-tab id="tab-home" md-label="Bugs" md-icon="bug_report">
                <nav-tabs-table></nav-tabs-table>
              </md-tab>

              <md-tab id="tab-pages" md-label="Website" md-icon="code">
                <nav-tabs-table></nav-tabs-table>
              </md-tab>

              <md-tab id="tab-posts" md-label="server" md-icon="cloud">
                <nav-tabs-table></nav-tabs-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
} from "@/components";
import moment from "moment";
export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
  },
  computed: {
    ...mapGetters([
      "messages",
      "clients",
      "service_providers",
      "active_sub_admins",
      "allUsers",
    ]),
    getAllMessagedUsers() {
      let cnt = 0;
      this.service_providers.forEach((selected_user) => {
        if (selected_user.message_connections != null) {
          //   this.allUsers.map()
          let arrs = Object.keys(selected_user.message_connections).map(
            (key) => {
              let use = this.allUsers.find(
                (item) => item.id == selected_user.message_connections[key].id
              );
              return {
                ...use,
                new_messages:
                  selected_user.message_connections[key].new_messages,
                last_time: selected_user.message_connections[key].last_time,
                last_date: selected_user.message_connections[key].last_date,
              };
            }
          );
          cnt = cnt + 1;
        } else {
        }
      });
      return cnt;
    },
  },
  created() {},
  data() {
    return {
      //   dailySalesChart: {
      //     data: {
      //       labels: ["M", "T", "W", "T", "F", "S", "S"],
      //       series: [[12, 17, 7, 17, 23, 18, 38]]
      //     },
      //     options: {
      //       lineSmooth: this.$Chartist.Interpolation.cardinal({
      //         tension: 0
      //       }),
      //       low: 0,
      //       high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //       chartPadding: {
      //         top: 0,
      //         right: 0,
      //         bottom: 0,
      //         left: 0
      //       }
      //     }
      //   },
      //   dataCompletedTasksChart: {
      //     data: {
      //       labels: ["9am", "12pm", "3pm", "6pm", "9pm",'12am'],
      //       series: [[ 450, 280, 240, 200, 1900,200]]
      //     },
      //     options: {
      //       lineSmooth: this.$Chartist.Interpolation.cardinal({
      //         tension: 0
      //       }),
      //       low: 0,
      //       high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
      //       chartPadding: {
      //         top: 0,
      //         right: 0,
      //         bottom: 0,
      //         left: 0
      //       }
      //     }
      //   },
      //   emailsSubscriptionChart: {
      //     data: {
      //       labels: [
      //         "Ja",
      //         "Fe",
      //         "Ma",
      //         "Ap",
      //         "Mai",
      //         "Ju",
      //         "Jul",
      //         "Au",
      //         "Se",
      //         "Oc",
      //         "No",
      //         "De"
      //       ],
      //       series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      //     },
      //     options: {
      //       axisX: {
      //         showGrid: false
      //       },
      //       low: 0,
      //       high: 1000,
      //       chartPadding: {
      //         top: 0,
      //         right: 5,
      //         bottom: 0,
      //         left: 0
      //       }
      //     },
      //     responsiveOptions: [
      //       [
      //         "screen and (max-width: 640px)",
      //         {
      //           seriesBarDistance: 5,
      //           axisX: {
      //             labelInterpolationFnc: function(value) {
      //               return value[0];
      //             }
      //           }
      //         }
      //       ]
      //     ]
      //   }
    };
  },
};
</script>
